// Admin AppBarTitle.

import React from 'react';
import { Stack, Box } from '@mui/material';
import Config from '../../lib/Config';
import { useState, useEffect } from 'react';
import '../../assets/style/fonts.css';
// import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Util from '../../lib/Util';
import Button from '@mui/material/Button';
import UIString from '../../assets/content/UIString';





const lang = Util.get_lang();

export default (props) => {


    const url_str = {
        ko: {
            admin: { label: '어드민', url: '/aaa' },
            dashboard: { label: 'Dashboard', url: Config.base_url + '/admin/dashboard' },
            mobile_app: { label: 'Mobile App', url: Config.base_url + '/admin/mobile_app' },
        }
    };

    // const navigate = useNavigate();
    const [navItems, setNavItems] = useState([]);

    useEffect(() => {
        let t_array = [];
        //let item_array = [];

        // if(  props.text != undefined ){item_array = props.text.split(';');}

        if (props.text != undefined && props.text.length > 0) {
            for (let i = 0; i < props.text.length; i++) {
                t_array.push(props.text[i]);
            }

            setNavItems(t_array);
        }



        /*
        let url_array = props.page.split(';');//document.location.pathname.split('/');
        
        if( url_str[url_array[1]] ){
            for( let i=3;i<url_array.length;i++ ){
                
                let label_str = '?';
                let label_url = '/';

                if( url_str[url_array[1]][url_array[i]]  ){
                    label_str = url_str[url_array[1]][url_array[i]].label;
                    label_url = url_str[url_array[1]][url_array[i]].url;
                }

                t_array.push({
                    label:label_str,
                    url:label_url
                });
            }
            
        setNavItems(t_array);
        console.log('nav items: ', navItems);
    }*/

    }, []);


    return (
        <div style={{width:'100%',height:'30px',paddingLeft:'8px',paddingRight:'8px',display:'flex',justifyContent:'space-between'}}>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                    sx={{ color: '#222222', fontSize: '14px', marginBottom: '16px', backgroundColor: '#ffffff' }}
                >
                    {/*navItems.map((item, index) => index == navItems.length - 1 ? <Link underline="" sx={{ color: '#222222' }}>{item.label}</Link> : <Link underline="hover" sx={{ color: '#222222', }} >{item.label}</Link>)*/}
                    {navItems.map((item, index) => <Link underline="" sx={{ color: '#222222' }}>{item}</Link>)}
                </Breadcrumbs>
        { props.right_button != undefined ? <span style={{fontSize:'11px',cursor:'pointer',paddingTop:'6px',paddingLeft:'8px',paddingRight:'8px'}} onClick={()=>{props.right_button_clicked()}}>{props.right_button}</span> : <></> }
        </div>
    );

}